"use client";

import { useApiGet } from "@/hooks/use-api";
import { integrationKeys } from "./keys";
import type { SlackConnectionStatus } from "./types";

/**
 * useSlackStatus
 *
 * Returns the Slack connection status for the current user.
 * Fetched only when the settings Connections tab opens (not pre-fetched globally).
 *
 * Usage:
 *   const { connected, slackTeamName, isLoading } = useSlackStatus();
 */
export function useSlackStatus() {
  const { data, isLoading, isError, refetch } = useApiGet<SlackConnectionStatus>(
    integrationKeys.slack(),
    "/api/slack/connection",
    undefined,
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );

  return {
    connected: data?.connected ?? false,
    slackTeamName: data?.slackTeamName,
    isLoading,
    isError,
    refetch,
  };
}
